import { request, ResponseProps } from "./request";

export const getRoles = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  const res: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}/auth/realms/${sessionStorage.getItem(
      "realm"
    )}/protocol/openid-connect/userinfo`
  );

  if (res) {
    return { success: true, data: res, message: "" };
  }
  return { success: false };
};
